import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Grid, Paper, Typography, } from '@mui/material';
import { useTokens } from '@mcn-platform/models';
import PanelTitle from '../PanelTitle';
import LearningObjectives from './LearningObjectives';
import ItemGlance from './ItemGlance';
const AboutContent = ({ course, program, action, buttonLabel, showPrice, settings, }) => {
    const tokens = useTokens();
    // if (course || program) return null;
    const isCourse = course !== undefined || program === undefined;
    const item = isCourse ? course : program;
    if (!item) {
        return null;
    }
    const { name, description, lessonCount, // startDate, expiryDate,
    enrollmentCount, gated, length, level, objectives, price, sellPrice, certification, } = item;
    const quizCount = item.calcQuizCount();
    const hasMaterials = item.hasMaterials();
    const hasCertification = item.hasCertification();
    const courseCount = item?.isProgram() ? item.calcCourseCount(true) : 0;
    const isScorm = item?.format === 'scorm12';
    return (_jsxs(Paper, { elevation: 0, sx: { display: 'flex', flexDirection: 'column' }, children: [settings.showTitle && (_jsx(PanelTitle, { title: tokens.getToken(isCourse ? 'courseAboutLabel' : 'programAboutLabel') })), _jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, xs: 12, md: 6, sx: {
                            pr: 1,
                            borderRight: (theme) => ({ xs: 'none', md: `1px solid ${theme.portal.site.lineColor}` }),
                        }, children: settings.showCourseObjectives && _jsx(LearningObjectives, { objectives: objectives, showDividers: false }) }), _jsx(Grid, { item: true, xs: 12, md: 6, sx: {
                            pr: { xs: 0, xl: 1 },
                            mt: { xs: 2.875, md: 0 },
                            pt: { xs: 2.875, md: 0 },
                            pl: { xs: 0, md: 3.25 },
                            borderTop: (theme) => ({ xs: `1px solid ${theme.portal.site.lineColor}`, md: 'none' }),
                            bgcolor: 'background.paper',
                        }, children: settings.showCourseStructure && (_jsx(ItemGlance, { isProgram: false, name: isCourse ? name : 'Program', settings: settings, certificationName: certification?.name, lessonCount: lessonCount, courseCount: courseCount, 
                            // startDate={startDate}
                            // expiryDate={expiryDate}
                            enrollmentCount: enrollmentCount, gated: gated, length: length, level: level, price: price, sellPrice: sellPrice, quizCount: quizCount, hasMaterials: hasMaterials, action: action, buttonLabel: buttonLabel, showPrice: showPrice, hasCertification: hasCertification, isCourse: isCourse, isScorm: isScorm })) }), _jsx(Grid, { item: true, xs: 12, sx: {
                            mt: 2,
                            pt: 2,
                            borderTop: (theme) => (`1px solid ${theme.portal.site.lineColor}`),
                        }, children: settings.showCourseDescription && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "subtitle1", className: "landingpage-section-subheader", children: tokens.getToken(isCourse ? 'courseDescriptionLabel' : 'programDescriptionLabel') }), _jsx(Typography, { sx: {
                                        pt: 1,
                                        pl: 2,
                                        // color: 'text.primary',
                                        // typography: 'body2',
                                        // fontSize: '0.90rem',
                                        whiteSpace: 'pre-line',
                                    }, className: "description", children: description })] })) })] })] }));
};
AboutContent.defaultProps = {
    course: undefined,
    program: undefined,
    settings: {
        showTitle: true,
        showCourseStructure: true,
        showCourseObjectives: true,
        showCourseDescription: true,
        showGatedDetail: true,
        showContentLengthDetail: true,
    },
};
AboutContent.meta = {
    group: 'hidden',
    name: 'Course About Tab',
    description: 'Component displays the course basic structure',
    props: [
        {
            key: 'course',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.showTitle',
            name: 'Show Title',
            type: 'boolean',
            description: 'Show the title on the about panel',
        },
        {
            key: 'settings.showCourseStructure',
            name: 'Show Course Structure',
            type: 'boolean',
            description: 'Show the basic course structure on the about panel',
        },
        {
            key: 'settings.showCourseObjectives',
            name: 'Show Course Objectives',
            type: 'boolean',
            description: 'Show the course learning objectives on the about panel',
        },
        {
            key: 'settings.showCourseDescription',
            name: 'Show Course Description',
            type: 'boolean',
            description: 'Show the course description on the about panel',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'About',
        courseData: '@course',
        enrollAction: '@enrollAction',
        props: {
            settings: {
                showTitle: true,
                showCourseStructure: true,
                showCourseObjectives: true,
                showCourseDescription: true,
            },
        },
    },
};
export default observer(AboutContent);
//# sourceMappingURL=AboutContent.js.map